import { ICommonSettings, IImageLibraryDto, IIosConfig, ILanguageModel } from "@kuika/kuika-cl-model";
import { Form } from "antd/es";
import { FormInstance } from "antd/es/form";
import { PureComponent, ReactNode } from "react";
import OrientationAnySvg from "../../../../svgs/orientation-any.svg";
import OrientationLandscapeSvg from "../../../../svgs/orientation-landscape.svg";
import OrientationPortraitSvg from "../../../../svgs/orientation-portrait.svg";
import KuikaInput from "../../../ui-kit/kuika-input/kuika-input";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../ui-kit/kuika-selectbox/kuika-selectbox";
import { AppStoreConnectApiInput } from "./app-settings-config-app-store/app-settings-config-app-store-input";
import { ConfigAppleSignInInput } from "./app-settings-config-apple-sign-in/app-settings-config-apple-sign-in-input";
import { ConfigBluetoothInput } from "./app-settings-config-bluetooth/app-settings-config-bluetooth-input";
import { ConfigCameraInput } from "./app-settings-config-camera/app-settings-config-camera.input";
import { ICommonConfigDeleteFunctionParams, ICommonConfigSaveFunctionParams } from "./app-settings-config-container";
import { FavIconField } from "./app-settings-config-favicon/app-settings-config-favicon-input";
import { ConfigFirebaseIOSInput } from "./app-settings-config-firebase/app-settings-config-firebase-ios-input";
import { ConfigGenerationTypeInput } from "./app-settings-config-generation-type/app-settings-config-generation-type-input";
import { GoogleRecaptchaIosInput } from "./app-settings-config-google-recaptcha/app-settings-config-google-recaptcha-ios-input";
import { ConfigGpsTrackingBackgroundPermissionInput } from "./app-settings-config-gps-tracker/app-settings-config-gps-tracker-background-permission.-input";
import { ConfigGpsTrackingInput } from "./app-settings-config-gps-tracker/app-settings-config-gps-tracker-input";
import { ConfigGpsTrackingPermissionInput } from "./app-settings-config-gps-tracker/app-settings-config-gps-tracker-permission-input";
import { ConfigIsHapticEnabled } from "./app-settings-config-is-haptic/app-settings-config-is-haptic-enabled-input";
import { ConfigLocationInput } from "./app-settings-config-location/app-settings-config-location-input";
import { ConfigNotificationPermissionInput } from "./app-settings-config-permission-text/app-settings-config-permission-text-input";
import { ConfigPushNotificationInput } from "./app-settings-config-push-notification/app-settings-config-push-notification-input";
import { SplashInput } from "./app-settings-config-splash/app-settings-config-splash-inputs";
import { IConfigCategory, IOS_CATEGORIES, visibleCategories } from "./config-categories";
import { ConfigField, ConfigSection, ConfigSupportToggle } from "./config-pane-parts";
import {
  ConfigCategoryStatus,
  ConfigDifference,
  ConfigPaneShell,
  ConfigRestorableValue,
  getOverriddenCategoryIds,
  readCategoryInheritance,
  restoreCategory
} from "./config-pane-shell";

const IOS_ORIENTATIONS: KuikaSelectboxOption[] = [
  {
    value: "any",
    searchLabel: "All orientation",
    label: (
      <span className="kuika-config-option">
        <OrientationAnySvg />
        <span data-testid="iosAllorientationSelection">All orientation</span>
      </span>
    )
  },
  {
    value: "portrait",
    searchLabel: "Portrait",
    label: (
      <span className="kuika-config-option">
        <OrientationPortraitSvg />
        <span data-testid="iosPortraitSelection">Portrait</span>
      </span>
    )
  },
  {
    value: "landscape",
    searchLabel: "Landscape",
    label: (
      <span className="kuika-config-option">
        <OrientationLandscapeSvg />
        <span data-testid="iosLandscapeSelection">Landscape</span>
      </span>
    )
  }
];

const IOS_DEVICES: KuikaSelectboxOption[] = [
  {
    value: 0,
    searchLabel: "All",
    label: (
      <span className="kuika-config-option">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M15.6248 17.2915H11.0415C10.3514 17.2915 9.7915 16.7316 9.7915 16.0415V7.2915C9.7915 6.6014 10.3514 6.0415 11.0415 6.0415H15.6248C16.3149 6.0415 16.8748 6.6014 16.8748 7.2915V16.0415C16.8748 16.7316 16.3149 17.2915 15.6248 17.2915Z"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.9585 14.7915H12.7085"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.33333 13.9583H4.375C3.6849 13.9583 3.125 13.3984 3.125 12.7083V3.95825C3.125 3.26815 3.6849 2.70825 4.375 2.70825H12.2917C12.9818 2.70825 13.5417 3.26815 13.5417 3.95825V4.58325"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeLinejoin="round"
          />
          <path
            d="M8.33317 10.8333H7.2915C6.94645 10.8333 6.6665 11.1132 6.6665 11.4583C6.6665 11.8033 6.94645 12.0833 7.2915 12.0833H8.33317V10.8333Z"
            fill="currentColor"
          />
        </svg>
        <span data-testid="iosAllDevicesSelection">All</span>
      </span>
    )
  },
  {
    value: 1,
    searchLabel: "Phones",
    label: (
      <span className="kuika-config-option">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.125 17.7084H6.875C6.1849 17.7084 5.625 17.1485 5.625 16.4584V3.54175C5.625 2.85164 6.1849 2.29175 6.875 2.29175H13.125C13.8151 2.29175 14.375 2.85164 14.375 3.54175V16.4584C14.375 17.1485 13.8151 17.7084 13.125 17.7084Z"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.0418 15.2085H8.9585"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.625 4.79175C10.625 5.1368 10.3451 5.41675 10 5.41675C9.65495 5.41675 9.375 5.1368 9.375 4.79175C9.375 4.4467 9.65495 4.16675 10 4.16675C10.3451 4.16675 10.625 4.4467 10.625 4.79175Z"
            fill="currentColor"
          />
        </svg>
        <span data-testid="iosPhonesSelection">Phones</span>
      </span>
    )
  },
  {
    value: 2,
    searchLabel: "Tablets",
    label: (
      <span className="kuika-config-option">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M17.2918 5.20825V14.7916C17.2918 15.4817 16.7319 16.0416 16.0418 16.0416H3.9585C3.26839 16.0416 2.7085 15.4817 2.7085 14.7916V5.20825C2.7085 4.51815 3.26839 3.95825 3.9585 3.95825H16.0418C16.7319 3.95825 17.2918 4.51815 17.2918 5.20825Z"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.8335 10C5.8335 10.3451 5.55355 10.625 5.2085 10.625C4.86344 10.625 4.5835 10.3451 4.5835 10C4.5835 9.65495 4.86344 9.375 5.2085 9.375C5.55355 9.375 5.8335 9.65495 5.8335 10Z"
            fill="currentColor"
          />
        </svg>
        <span data-testid="iosTabletsSelection">Tablets</span>
      </span>
    )
  }
];

export interface IIOSConfigProps {
  /**
   * The container's whole parent/child difference, not just this pane's slice: a
   * category can own a key that lives on another one, and Restore writes it by its
   * full path. The rows below read `parentChildDifferences`, which narrows it.
   */
  parentChildDifference?: ConfigDifference;
  /** Form paths edited since the configuration was opened — the rail's dots and the orange labels. */
  changedPaths?: ReadonlySet<string>;
  /** Puts the named paths back to what they were when the configuration was opened. */
  onRevertPaths?: (paths: string[]) => void;
  /** True only when this configuration inherits from a workspace one. */
  hasParentConfig?: boolean;
  isGlobalConfig?: boolean;
  allImage?: IImageLibraryDto[];
  handleGetImageLibrary: () => void;
  languages: ILanguageModel[];
  commonSettings: ICommonSettings;
  getSectionDescription: (contentKey: string) => ReactNode;
  handleUpdateCustomFormInput: (formItemName: string[], value: ConfigRestorableValue) => void;
  handleCreateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleUpdateCommonConfig: (params: ICommonConfigSaveFunctionParams) => void;
  handleDeleteCommonConfig: (params: ICommonConfigDeleteFunctionParams) => void;
  isSupporting: boolean;
  toggleSupport: () => void;
}

export interface IIOSConfigState {
  /** The rail's selection. Pane-local, so it survives a trip through another platform tab. */
  activeCategoryId: string;
}

interface IIOSSection {
  description?: ReactNode;
  titleTestId?: string;
  descriptionTestId?: string;
  body: ReactNode;
}

/** The categories a workspace configuration has nothing to say about. */
const GLOBAL_HIDDEN_CATEGORIES: string[] = [
  "iosMobileAppSettings",
  "iosGeolocation",
  "iosCamera",
  "iosBluetooth",
  "iosGpsTracker"
];

export class IOSConfig extends PureComponent<IIOSConfigProps, IIOSConfigState> {
  constructor(props: IIOSConfigProps) {
    super(props);
    this.state = { activeCategoryId: IOS_CATEGORIES[0].id };
  }

  getCategories = (): IConfigCategory[] =>
    visibleCategories(IOS_CATEGORIES, this.props.isGlobalConfig ? GLOBAL_HIDDEN_CATEGORIES : []);

  /** The selection, corrected for a category that has gone away under it. */
  getActiveCategory = (): IConfigCategory => {
    const categories: IConfigCategory[] = this.getCategories();
    const selected: IConfigCategory | undefined = categories.find(
      (category: IConfigCategory): boolean => category.id === this.state.activeCategoryId
    );
    return selected ?? categories[0];
  };

  handleSelectCategory = (categoryId: string): void => {
    this.setState({ activeCategoryId: categoryId });
  };

  /**
   * This pane's own slice of the difference — what the per-row restore affordances read.
   * A row only ever overrides a key on the slice it writes to.
   */
  get parentChildDifferences(): IIosConfig | undefined {
    return this.props.parentChildDifference?.iosConfig as IIosConfig | undefined;
  }

  handleRestoreCategory = (): void => {
    restoreCategory(
      this.getActiveCategory(),
      this.props.parentChildDifference,
      "iosConfig",
      this.props.handleUpdateCustomFormInput
    );
  };

  renderMobileAppSettings = (): ReactNode => (
    <>
      <ConfigField label="App Name" required tooltipContentKey="ios_mobileappsettings_appname">
        <Form.Item
          name={["iosConfig", "appName"]}
          rules={[{ required: this.props.isSupporting, message: "IOS App Name is required" }]}
        >
          <KuikaInput size="md" data-testid="iosAppNameInput" placeholder="MyApp" />
        </Form.Item>
      </ConfigField>

      <ConfigField label="Bundle ID" required tooltipContentKey="ios_mobileappsettings_bundleid">
        <Form.Item
          name={["iosConfig", "appBundleId"]}
          rules={[
            { required: this.props.isSupporting, message: "IOS App Bundle ID is required" },
            {
              pattern: /^[a-zA-Z0-9]+((\.(-\.)*-?|-(\.-)*\.?)[a-zA-Z0-9]+)*$/gm,
              message:
                "IOS App Bundle ID can only contain alphanumeric characters, hyphens, and periods. It can't end on a period."
            }
          ]}
        >
          <KuikaInput size="md" data-testid="iosBundleIdInput" placeholder="com.workspace.project_name" />
        </Form.Item>
      </ConfigField>

      <ConfigField label="Version" required tooltipContentKey="ios_mobileappsettings_version">
        <Form.Item
          name={["iosConfig", "appVersion"]}
          rules={[
            { required: this.props.isSupporting, message: "IOS App Version is required" },
            { pattern: /^(\d+\.)?(\d+\.)?(\*|\d+)$/g, message: "Please enter a valid IOS App Version" }
          ]}
        >
          <KuikaInput size="md" data-testid="iosVersionInput" placeholder="1.0.0" style={{ marginBottom: 0 }} />
        </Form.Item>
      </ConfigField>

      <ConfigIsHapticEnabled parentData="iosConfig" />
    </>
  );

  getSections = (): Record<string, IIOSSection> => ({
    iosMobileAppSettings: {
      description: this.props.getSectionDescription("ios_mobileappsettings_description"),
      titleTestId: "iosMobileAppSettingsTitle",
      descriptionTestId: "iosMobileAppSettingsDescription",
      body: this.renderMobileAppSettings()
    },
    iosAppleSignIn: {
      description: this.props.getSectionDescription("ios_applesigninsettings_description"),
      titleTestId: "appleSignInSettingsTitle",
      descriptionTestId: "appleSignInSettingsDescription",
      body: (
        <ConfigAppleSignInInput
          parentConfigValue={this.parentChildDifferences?.appleSigninSettingsId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleUpdateCustomFormInput={this.props.handleUpdateCustomFormInput}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
      )
    },
    iosAppStore: {
      description: this.props.getSectionDescription("ios_appstoresettings_description"),
      titleTestId: "appStoreSettingsTitle",
      descriptionTestId: "appStoreSettingsDescription",
      body: (
        <AppStoreConnectApiInput
          parentConfigValue={this.parentChildDifferences?.appStoreConnectApiSettingsId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleUpdateCustomFormInput={this.props.handleUpdateCustomFormInput}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
      )
    },
    iosFirebase: {
      description: this.props.getSectionDescription("ios_firebase_description"),
      titleTestId: "firebaseSettingsTitle",
      descriptionTestId: "firebaseSettingsDescription",
      body: (
        <ConfigFirebaseIOSInput
          parentConfigValue={this.parentChildDifferences?.firebaseSettingsId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleUpdateCustomFormInput={this.props.handleUpdateCustomFormInput}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
      )
    },
    iosGeolocation: {
      description: this.props.getSectionDescription("ios_location_description"),
      titleTestId: "iosGeoLocationTitle",
      descriptionTestId: "iosGeolocationDescription",
      body: (
        <ConfigLocationInput
          parentData="iosConfig"
          languages={this.props.languages}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
      )
    },
    iosCamera: {
      description: this.props.getSectionDescription("ios_camera_description"),
      titleTestId: "iosCameraTitle",
      descriptionTestId: "iosCameraDescription",
      body: (
        <ConfigCameraInput
          parentData="iosConfig"
          languages={this.props.languages}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
      )
    },
    iosBluetooth: {
      description: this.props.getSectionDescription("ios_bluetooth_description"),
      titleTestId: "iosBluetoothTitle",
      descriptionTestId: "iosBluetoothDescription",
      body: (
        <ConfigBluetoothInput
          parentData="iosConfig"
          languages={this.props.languages}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
      )
    },
    iosGpsTracker: {
      description: this.props.getSectionDescription("ios_gpstracker_description"),
      titleTestId: "iosGpsTrackerTitle",
      descriptionTestId: "iosGpsTrackerDescription",
      body: (
        <>
          <ConfigGpsTrackingInput
            parentData="iosConfig"
            commonSettings={this.props.commonSettings}
            getSectionDescription={this.props.getSectionDescription}
            handleCreateCommonConfig={this.props.handleCreateCommonConfig}
            handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
            handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
          />
          <ConfigGpsTrackingPermissionInput
            parentData="iosConfig"
            languages={this.props.languages}
            commonSettings={this.props.commonSettings}
            getSectionDescription={this.props.getSectionDescription}
            handleCreateCommonConfig={this.props.handleCreateCommonConfig}
            handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
            handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
          />
          <ConfigGpsTrackingBackgroundPermissionInput
            parentData="iosConfig"
            languages={this.props.languages}
            commonSettings={this.props.commonSettings}
            getSectionDescription={this.props.getSectionDescription}
            handleCreateCommonConfig={this.props.handleCreateCommonConfig}
            handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
            handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
          />
        </>
      )
    },
    iosPushNotification: {
      description: this.props.getSectionDescription("ios_pushnotification_description"),
      titleTestId: "iosPushNotificationTitle",
      descriptionTestId: "iosPushNotificationDescription",
      body: (
        <>
          <ConfigPushNotificationInput
            parentData="iosConfig"
            parentConfigValue={this.parentChildDifferences?.pushNotificationSettingsId}
            commonSettings={this.props.commonSettings}
            getSectionDescription={this.props.getSectionDescription}
            handleUpdateCustomFormInput={this.props.handleUpdateCustomFormInput}
            handleCreateCommonConfig={this.props.handleCreateCommonConfig}
            handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
            handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
          />
          {/* The permission prompt's wording is a project's copy, not a workspace default. */}
          {!this.props.isGlobalConfig && (
            <ConfigNotificationPermissionInput
              parentData="iosConfig"
              languages={this.props.languages}
              commonSettings={this.props.commonSettings}
              getSectionDescription={this.props.getSectionDescription}
              handleCreateCommonConfig={this.props.handleCreateCommonConfig}
              handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
              handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
            />
          )}
        </>
      )
    },
    iosGoogleRecaptcha: {
      description: this.props.getSectionDescription("iosconfig_googlerecaptcha_description"),
      titleTestId: "iosGoogleRecaptchaTitle",
      body: (
        <GoogleRecaptchaIosInput
          parentConfigValue={this.parentChildDifferences?.googleRecaptchaIosSettingsId}
          commonSettings={this.props.commonSettings}
          getSectionDescription={this.props.getSectionDescription}
          handleUpdateCustomFormInput={this.props.handleUpdateCustomFormInput}
          handleCreateCommonConfig={this.props.handleCreateCommonConfig}
          handleUpdateCommonConfig={this.props.handleUpdateCommonConfig}
          handleDeleteCommonConfig={this.props.handleDeleteCommonConfig}
        />
      )
    }
  });

  /** Orientation and device family: the app's shape, not any one category's setting. */
  renderOptions = (): ReactNode => (
    <ConfigSection rail title="Options" titleTestId="iosOptionsTitle">
      <ConfigField
        aside
        label="Orientation"
        labelTestId="iosOrientationText"
        tooltipContentKey="ios_options_orientation"
      >
        <Form.Item name={["iosConfig", "orientation"]}>
          <KuikaSelectbox size="md" data-testid="iosOrientationDropdown" options={IOS_ORIENTATIONS} />
        </Form.Item>
      </ConfigField>

      <ConfigField aside label="Devices" labelTestId="iosDevicesTitle" tooltipContentKey="ios_options_devices">
        <Form.Item name={["iosConfig", "deviceType"]}>
          <KuikaSelectbox size="md" data-testid="iosDevicesDropdown" options={IOS_DEVICES} />
        </Form.Item>
      </ConfigField>
    </ConfigSection>
  );

  renderAside = (): ReactNode => {
    const { isGlobalConfig } = this.props;

    return (
      <>
        {!isGlobalConfig && (
          <ConfigSupportToggle
            label="Support IOS UI"
            description={this.props.getSectionDescription("ios_supportios_description")}
            checked={this.props.isSupporting}
            onChange={this.props.toggleSupport}
            switchTestId="supportIosSwitch"
            descriptionTestId="supportiosDescription"
            aside
          />
        )}

        {/* Decides which generator the whole tab is compiled into, so it sits with the platform's
            support switch rather than under one category. The control owns its section and hides it —
            for everyone while React Native is on hold, and outside the closed beta otherwise (see
            `ConfigGenerationTypeInput`). Keep the Form.Item mounted either way: save rebuilds the
            configuration from the mounted fields, so dropping it would drop the saved value. */}
        {!isGlobalConfig && this.props.isSupporting && (
          <Form.Item name="iosGenerationType" noStyle>
            <ConfigGenerationTypeInput
              platform="ios"
              sectionDescription={
                this.props.getSectionDescription("appsettings_mobilegenerationtype_description") ??
                "Choose how this configuration's iOS application is generated. Native produces the iOS (Swift) project. React Native produces an Expo project, shared with Android when Android is set to React Native too."
              }
            />
          </Form.Item>
        )}

        {this.props.hasParentConfig && (
          <ConfigCategoryStatus
            inheritance={readCategoryInheritance(
              this.getActiveCategory(),
              this.props.parentChildDifference,
              "iosConfig"
            )}
            onRestore={this.handleRestoreCategory}
          />
        )}

        {!isGlobalConfig && (
          <>
            {this.renderOptions()}

            <ConfigSection
              rail
              title="App Icons"
              titleTestId="iosAppIconsTitle"
              description="32x32 px and JPG or PNG file"
            >
              <ConfigField aside label="Square">
                <Form.Item name={["iosConfig", "iconFileName"]} noStyle>
                  <FavIconField
                    acceptTpye=".jpg,.png"
                    allImage={this.props.allImage}
                    handleGetImageLibrary={() => {
                      this.props.handleGetImageLibrary();
                    }}
                  />
                </Form.Item>
              </ConfigField>
            </ConfigSection>

            <ConfigSection rail title="Splash" titleTestId="iosSplashTitle">
              {/* Registration only. The picker below writes these three through
                  `handleUpdateCustomFormInput`, and a value with no named `Form.Item` is absent
                  from `onFinish` — the splash would mark as changed and then silently not save. */}
              <Form.Item name={["iosConfig", "splashScreenImageName"]} hidden>
                <input type="hidden" />
              </Form.Item>
              <Form.Item name={["iosConfig", "splashScreenBackcolor"]} hidden>
                <input type="hidden" />
              </Form.Item>
              <Form.Item name={["iosConfig", "imageFit"]} hidden>
                <input type="hidden" />
              </Form.Item>
              {/* Explicit path: the control below is a `shouldUpdate` watcher, not a `Form.Item`
                  with a `name`, so the label/path discovery walk in `readFieldPath` finds
                  nothing to register on its own. */}
              <ConfigField
                aside
                label="Image"
                labelTestId="iosImageText"
                hint="PNG and max file size 300KB"
                formInputName={["iosConfig", "splashScreenImageName"]}
              >
                <Form.Item
                  shouldUpdate={(prev, current): boolean =>
                    prev.iosConfig?.splashScreenImageName !== current.iosConfig?.splashScreenImageName ||
                    prev.iosConfig?.splashScreenBackcolor !== current.iosConfig?.splashScreenBackcolor ||
                    prev.iosConfig?.imageFit !== current.iosConfig?.imageFit
                  }
                  noStyle
                >
                  {({ getFieldValue }: FormInstance): ReactNode => (
                    <SplashInput
                      parentData="iosConfig"
                      allImage={this.props.allImage}
                      splashImage={getFieldValue(["iosConfig", "splashScreenImageName"])}
                      splashBgColor={getFieldValue(["iosConfig", "splashScreenBackcolor"])}
                      splashFitting={getFieldValue(["iosConfig", "imageFit"])}
                      handleGetImageLibrary={() => {
                        this.props.handleGetImageLibrary();
                      }}
                      onImageChange={(image: string | null): void =>
                        this.props.handleUpdateCustomFormInput(["iosConfig", "splashScreenImageName"], image)
                      }
                      onColorChange={(color: string): void =>
                        this.props.handleUpdateCustomFormInput(["iosConfig", "splashScreenBackcolor"], color)
                      }
                      onFittingChange={(fitting: "default" | "stretch"): void =>
                        this.props.handleUpdateCustomFormInput(["iosConfig", "imageFit"], fitting)
                      }
                    />
                  )}
                </Form.Item>
              </ConfigField>
            </ConfigSection>
          </>
        )}
      </>
    );
  };

  render() {
    const categories: IConfigCategory[] = this.getCategories();
    const sections: Record<string, IIOSSection> = this.getSections();
    const activeCategoryId: string = this.getActiveCategory().id;

    return (
      <ConfigPaneShell
        changedPaths={this.props.changedPaths}
        onRevertPaths={this.props.onRevertPaths}
        categories={categories}
        activeCategoryId={activeCategoryId}
        onSelectCategory={this.handleSelectCategory}
        overriddenCategoryIds={getOverriddenCategoryIds(categories, this.props.parentChildDifference, "iosConfig")}
        bodyVisible={this.props.isSupporting}
        aside={this.renderAside()}
      >
        {/* Every category stays mounted; `ConfigSection` hides the ones the rail is not
            pointing at. One antd Form spans all of them and save reads `getFieldsValue()`,
            so a category taken out of the tree is a field written back empty. */}
        {categories.map((category: IConfigCategory) => (
          <ConfigSection
            key={category.id}
            categoryId={category.id}
            active={category.id === activeCategoryId}
            title={category.label}
            description={sections[category.id]?.description}
            titleTestId={sections[category.id]?.titleTestId}
            descriptionTestId={sections[category.id]?.descriptionTestId}
          >
            {sections[category.id]?.body}
          </ConfigSection>
        ))}
      </ConfigPaneShell>
    );
  }
}
